const formattedFilmStripData = (videoPlacementPosition, productImagesAndVideos) => {
    const videoObjects = productImagesAndVideos?.filter((obj) => obj?.isVideo === true);
    if (videoObjects?.length === 0) return productImagesAndVideos;

    const arrayWithoutVideos = productImagesAndVideos?.filter((obj) => {
        return (
            !videoObjects.includes(obj) ||
            videoObjects.indexOf(obj) !== videoObjects.lastIndexOf(obj)
        );
    });

    arrayWithoutVideos.splice(videoPlacementPosition - 1, 0, ...videoObjects);
    return arrayWithoutVideos;
};

export default formattedFilmStripData;
